export const removeNewLines = (str: string) => str.replace(/\n+/g, ' ・ ');
